






import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TrainInfo extends Vue {
  // 現在の鉄道運行情報画像
  private url = '';

  // 鉄道運行情報画像
  private items: string[] = [];

  // インターバル
  private interval?: number;

  // 現在の表示インデックス
  private index?: number;

  // タイマーiD
  private timerID?: number;

  /**
   * 鉄道運行情報画像を取得
   */
  get currentImages(): string[] {
    return this.items;
  }

  activated() {
    const uri = process.env.VUE_APP_API_DOMAIN + '/api/traininfo';
    this.axios.get(uri).then(response => {
      this.items = response.data.items;
      this.interval = response.data.interval;

      // キャッシュを更新
      this.items = this.items.map(item => item + '?' + new Date().getTime());

      // インターバル開始
      this.next();
    });
  }

  deactivated() {
    clearTimeout(this.timerID);
  }

  /**
   * 次の画像を表示する
   */
  private next() {
    if (this.index != undefined) {
      this.index++;
      if (this.index > this.items.length - 1) {
        this.index = 0;
      }
    } else {
      this.index = 0;
    }
    this.url = this.items[this.index];
    clearTimeout(this.timerID);
    this.timerID = setTimeout(this.next.bind(this), this.interval);
  }
}
